import React, { useState } from 'react';
import { 
  DataGrid, 
  GridToolbar,
  GridActionsCellItem 
} from '@mui/x-data-grid';
import { 
  Eye, 
  Edit, 
  RefreshCw,
  CheckCircle,
  XCircle,
  Clock,
  AlertCircle,
  User,
  Calendar,
  DollarSign,
  Filter,
  Search
} from 'lucide-react';
import { 
  Chip,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  TextField,
  InputAdornment
} from '@mui/material';
import useFetchTableData from '../../hooks/useFetchTableData';
import adminApi from '../../api/admin';
import Button from '../../components/common/Button';
import DataTable from '../../components/common/DataTable';
import { formatDateForDisplay } from '../../utils/helpers';
import { Link } from 'react-router-dom';

const AdminSubscriptionsListPage = () => {
  const [filters, setFilters] = useState({
    status: "all",
    search: "",
  });

  const {
    data,
    isLoading,
    isError,
    error,
    paginationModel,
    setPaginationModel,
  } = useFetchTableData({
    queryKey: "subscriptions",
    fetchFunc: adminApi.getSubscriptions,
    params: filters,
  });

  // Define columns for the DataGrid
  const columns = [
    // { 
    //   field: 'id', 
    //   headerName: 'ID', 
    //   width: 80,
    //   align: 'center',
    //   headerAlign: 'center',
    //   renderCell: (params) => (
    //           <div className="flex items-center space-x-3">
                
    //             <Link
    //               to={`${params.row.id}`}
    //               className="text-blue-600 hover:underline font-semibold"
    //             >
    //               {params.value}
    //             </Link>
    //           </div>
    //         ),
    // },
    { 
      field: 'plan_name', 
      headerName: 'Plan', 
      flex: 1,
      minWidth: 180,
      renderCell: (params) => (
        <div>
          <div className="font-semibold text-secondary-900">
             <Link
                  to={`${params.row.id}`}
                  className="text-blue-600 hover:underline font-semibold"
                >
                  {/* {params.value} */}
            {params.row.plan?.name}
                </Link>
          </div>
          {/* <div className="text-xs text-secondary-600">
            {params.row.plan?.target_role && (
              <span className="capitalize">{params.row.plan.target_role}</span>
            )}
          </div> */}
        </div>
      )
    },
    { 
      field: 'user', 
      headerName: 'User Email', 
      // flex: 1,
      minwidth: 200,
      align: 'start',
      // headerAlign: 'center',
      renderCell: (params) => (
        <Link
                  to={`/admin/users/${params.row.user}`}
                  className="text-blue-600 hover:underline font-semibold"
                >
        {/* <div className="flex justify-center"> */}
          {/* <User className="w-4 h-4 mr-1 text-gray-500" /> */}

          {params.row.user_email}
        {/* </div> */}
                </Link>
      )
    },
    
    { 
      field: 'price', 
      headerName: 'Price', 
      width: 120,
      renderCell: (params) => (
        <div className="flex items-center">
          {/* <DollarSign className="w-4 h-4 mr-1 text-green-600" /> */}
          <span className="font-semibold">{params.row.plan?.price}</span>
          <span className="text-xs text-secondary-600 ml-1">
            {params.row.plan?.currency}
          </span>
        </div>
      )
    },
    { 
      field: 'status', 
      headerName: 'Status', 
      width: 130,
      renderCell: (params) => {
        const statusConfig = {
          active: { color: 'success', label: 'Active', icon: CheckCircle },
          pending: { color: 'warning', label: 'Pending', icon: Clock },
          canceled: { color: 'error', label: 'Cancelled', icon: XCircle },
          expired: { color: 'default', label: 'Expired', icon: AlertCircle },
          suspended: { color: 'error', label: 'Suspended', icon: XCircle }
        };
        
        const config = statusConfig[params.value] || { color: 'default', label: params.value, icon: AlertCircle };
        
        return (
          <Chip 
            label={config.label}
            color={config.color}
            size="small"
            icon={<config.icon className="w-4 h-4" />}
          />
        );
      }
    },
    { 
      field: 'payment_method', 
      headerName: 'Payment Method', 
      width: 140,
      renderCell: (params) => (
        <span className="capitalize">{params.value || 'N/A'}</span>
      )
    },
    { 
          field: 'start_date', 
          headerName: 'Start Date', 
          width: 120,
          type: "date",
          valueGetter: (params) => (params ? new Date(params) : null),
                renderCell: (params) => {
                  return params.row.start_date
                    ? formatDateForDisplay(params.row.start_date)
                    : "";
                },
        },
        { 
          field: 'end_date', 
          headerName: 'End Date', 
          width: 120,
          type: "date",
          valueGetter: (params) => (params ? new Date(params) : null),
                renderCell: (params) => {
                  return params.row.end_date
                    ? formatDateForDisplay(params.row.end_date)
                    : "";
                },
        },
    { 
      field: 'auto_renew', 
      headerName: 'Auto Renew', 
      width: 110,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Chip 
          label={params.value ? 'Yes' : 'No'} 
          color={params.value ? 'success' : 'default'}
          size="small"
          variant="outlined"
        />
      )
    },
    { 
      field: 'job_postings_count', 
      headerName: 'Job Posts', 
      width: 100,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <div className="text-center">
          <div className="font-semibold">{params.value || 0}</div>
          {/* <div className="text-xs text-secondary-600">
            {params.row.job_postings_remaining >= 0 ? `${params.row.job_postings_remaining} left` : 'Unlimited'}
          </div> */}
        </div>
      )
    },
    { 
      field: 'profile_views_count', 
      headerName: 'Profile Views', 
      width: 110,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <div className="text-center">
          <div className="font-semibold">{params.value || 0}</div>
          {/* <div className="text-xs text-secondary-600">
            {params.row.profile_views_remaining >= 0 ? `${params.row.profile_views_remaining} left` : 'Unlimited'}
          </div> */}
        </div>
      )
    },
    // {
    //   field: 'actions',
    //   type: 'actions',
    //   headerName: 'Actions',
    //   width: 120,
    //   getActions: (params) => [
    //     <GridActionsCellItem
    //       icon={<Eye className="w-4 h-4" />}
    //       label="View Details"
    //       onClick={() => handleView(params.row)}
    //       showInMenu
    //     />,
    //     <GridActionsCellItem
    //       icon={<Edit className="w-4 h-4" />}
    //       label="Edit Subscription"
    //       onClick={() => handleEdit(params.row)}
    //       showInMenu
    //     />,
    //     <GridActionsCellItem
    //       icon={<RefreshCw className="w-4 h-4" />}
    //       label="Refresh Status"
    //       onClick={() => handleRefresh(params.row)}
    //       showInMenu
    //     />,
    //   ],
    // },
  ];

  // Handler functions
  const handleView = (subscription) => {
    console.log('View subscription:', subscription);
    // Navigate to subscription details page
    // navigate(`/admin/subscriptions/${subscription.id}`);
  };

  const handleEdit = (subscription) => {
    console.log('Edit subscription:', subscription);
    // Navigate to edit subscription page
    // navigate(`/admin/subscriptions/${subscription.id}/edit`);
  };

  const handleRefresh = (subscription) => {
    console.log('Refresh subscription:', subscription);
    // Implement refresh logic
  };

  const handleStatusFilterChange = (event) => {
    setFilters(prev => ({
      ...prev,
      status: event.target.value
    }));
    // Reset to first page when filter changes
    setPaginationModel(prev => ({ ...prev, page: 0 }));
  };

  const handleSearchChange = (event) => {
    setFilters(prev => ({
      ...prev,
      search: event.target.value
    }));
  };

  const handleClearFilters = () => {
    setFilters({
      status: "all",
      search: "",
    });
    setPaginationModel(prev => ({ ...prev, page: 0 }));
  };

  // Check if any filters are active
  const hasActiveFilters = filters.status !== 'all' || filters.search;

  if (isError) {
    return (
      <div className="max-w-7xl mx-auto py-8 px-4">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-800">Error loading subscriptions: {error?.message}</p>
          <Button 
            onClick={() => window.location.reload()} 
            variant="outline" 
            className="mt-4"
            icon={<RefreshCw className="w-4 h-4 mr-2" />}
          >
            Retry
          </Button>
        </div>
      </div>
    );
  }
  

  return (
    <div className="max-w-7xl mx-auto py-8 px-4">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-secondary-900">Subscription Management</h1>
          <p className="text-secondary-600 mt-1">
            {data ? `Total: ${data.count} subscriptions` : 'Manage and monitor user subscriptions'}
          </p>
        </div>
        <div className="mt-4 sm:mt-0">
          <Button 
            onClick={handleClearFilters}
            variant="outline"
            disabled={!hasActiveFilters}
            icon={<RefreshCw className="w-4 h-4 mr-2" />}
          >
            Clear Filters
          </Button>
        </div>
      </div>
      

      {/* Filters */}
      <Card className="mb-6">
        <CardContent className="p-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex items-center space-x-4">
              <Filter className="w-5 h-5 text-secondary-500" />
              <Typography variant="subtitle1" className="text-secondary-900">
                Filters
              </Typography>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <TextField
                size="small"
                placeholder="Search subscriptions..."
                value={filters.search}
                onChange={handleSearchChange}
                slotProps={{input:{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search className="w-4 h-4 text-gray-400" />
                    </InputAdornment>
                  ),
                }}}
                className="w-full sm:w-64"
              />
              <FormControl size="small" className="min-w-[150px]">
                <InputLabel>Status</InputLabel>
                <Select
                  value={filters.status}
                  label="Status"
                  onChange={handleStatusFilterChange}
                >
                  <MenuItem value="all">All Statuses</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="cancelled">Cancelled</MenuItem>
                  <MenuItem value="expired">Expired</MenuItem>
                  <MenuItem value="suspended">Suspended</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* DataGrid */}
      <Card>
<DataTable

          rows={data?.results || []}
          columns={columns}
          loading={isLoading}
          rowCount={data?.count}
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
        //   pageSizeOptions={[10, 25, 50, 100]}
        //   slots={{
        //     toolbar: GridToolbar,
        //   }}
        //   slotProps={{
        //     toolbar: {
        //       showQuickFilter: true,
        //       quickFilterProps: { debounceMs: 500 },
        //     },
        //   }}
        //   sx={{
        //     border: 'none',
        //     '& .MuiDataGrid-cell': {
        //       borderBottom: '1px solid #f3f4f6',
        //     },
        //     '& .MuiDataGrid-columnHeaders': {
        //       backgroundColor: '#f9fafb',
        //       borderBottom: '2px solid #e5e7eb',
        //     },
        //     '& .MuiDataGrid-toolbarContainer': {
        //       padding: '16px',
        //       borderBottom: '1px solid #e5e7eb',
        //     },
        //     '& .MuiDataGrid-footerContainer': {
        //       borderTop: '1px solid #e5e7eb',
        //     },
        //     '& .MuiDataGrid-row:hover': {
        //       backgroundColor: '#f8fafc',
        //     },
        //   }}
        //   autoHeight
        //   disableRowSelectionOnClick
        //   getRowId={(row) => row.id}
        />
      </Card>

      {/* Empty State */}
      {!isLoading && data?.results?.length === 0 && (
        <Card className="mt-6">
          <CardContent className="text-center py-12">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <DollarSign className="w-8 h-8 text-gray-400" />
            </div>
            <Typography variant="h6" className="text-secondary-900 mb-2">
              No subscriptions found
            </Typography>
            <Typography variant="body2" className="text-secondary-600 mb-4">
              {hasActiveFilters 
                ? 'No subscriptions match your current filters.'
                : 'There are no subscriptions in the system yet.'
              }
            </Typography>
            {hasActiveFilters && (
              <Button 
                onClick={handleClearFilters}
                variant="outline"
              >
                Clear Filters
              </Button>
            )}
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default AdminSubscriptionsListPage;